import React from 'react';
import { MacScrollbar } from '../../vendor/mac-scrollbar';

export interface IScrollingContainer {
  suppressAutoHide?: boolean;
  suppressScrollX?: boolean;
  suppressScrollY?: boolean;
}

export const ScrollingContainer: React.FC<React.PropsWithChildren<IScrollingContainer & { scrollbarRef?: React.Ref<HTMLElement> }>> = ({
  children,
  suppressAutoHide = false,
  suppressScrollX = false,
  suppressScrollY = false,
  scrollbarRef,
  ...rest
}) => {
  return (
    <MacScrollbar ref={scrollbarRef} suppressScrollX={suppressScrollX} suppressScrollY={suppressScrollY} suppressAutoHide={suppressAutoHide} {...rest}>
      {children}
    </MacScrollbar>
  );
};
